<!--
  OwnerFilter is a filter component that allows the user to filter by owner.
  It reads/writes from the `creator` URL query param.
-->
<script>
import { mapActions, mapState } from 'vuex';
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {
    iFilter,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      allActiveUsers: [],
    };
  },
  computed: {
    ...mapState(['currentUser', 'tags']),
    ownersOptions() {
      const { email, uuid } = this.currentUser;
      return [
        { label: email, id: uuid },
        ...this.allActiveUsers
          .filter((user) => user.id !== uuid)
          .map((user) => ({
            label: user.email,
            id: user.id,
          })),
      ];
    },
    value() {
      const { creator } = this.params;
      if (!creator) {
        return [];
      }
      const creatorsArray = Array.isArray(creator) ? creator : [creator];
      return creatorsArray.map(
        (id) =>
          this.ownersOptions.find((option) => option.id === id)?.label || id,
      );
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    ...mapActions(['getUsers']),
    loadUsers() {
      this.getUsers({ include_api_users: true }).then((users) => {
        this.allActiveUsers = users.data?.data.filter(
          (user) => user.registration_confirmed && user.is_active,
        );
      });
    },
    onSelectionChanged(updated) {
      const updatedIds = updated.selection.map((t) => t.id);
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          creator: updatedIds.length === 0 ? undefined : updatedIds.join(','),
        },
      });
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: 'owner-filter',
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Owner"
    data-testid="customer-owner-filter"
    data-dd-action-name="customers-view-owner-filter"
    :options="ownersOptions"
    :value="value"
    :max-selectable="1"
    :searchable="true"
    @selection-changed="onSelectionChanged"
  />
</template>
